import CookiesUtils from '@utils/CookiesUtils';

// Should match with ApplicationController#fetch_territories_from_cookies key
export const TERRITORY_SELECTION_COOKIE = 'global_scope_territory_selections';

export const hasGlobalTerritoriesApplied = () => {
  const storedSelections = CookiesUtils.getCookie(TERRITORY_SELECTION_COOKIE);

  if (!storedSelections) return false;

  // Extract the current subdomain from the hostname (first part before the first dot)
  if (typeof window === 'undefined' || !window.location?.hostname) return false;
  const parts = window.location.hostname.split('.');
  const currentSubdomain = parts[0];

  // Parse the cookie JSON safely
  // The cookie is expected to be in the format: { "subdomain": [ids] }
  let territorySelections = [];
  try {
    const parsed = JSON.parse(storedSelections);
    territorySelections = parsed[currentSubdomain] || [];
  } catch (e) {
    // If parsing fails, assume no selections
    territorySelections = [];
  }

  return territorySelections.length > 0;
};
